import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class ResolutionCodingService {
  private http = inject(HttpClient);

  resolutionData: any;
  practiceIssueData: any;
  init() {
    this.http
      .get(environment.apiUrl + "get/resolution_codes")
      .subscribe((res) => {
        this.resolutionData = (res as any)[0];
        this.practiceIssueData = (res as any)[1];
      });
  }

  getReolutionCodingBg(resolution: any) {
    try {
      return "res-bg-" + this.resolutionData[resolution]["color"];
    } catch {
      return "";
    }
  }

  getRosolutionCodingData(module: any) {
    const data: any[] = [];
    Object.keys(this.resolutionData)
      .sort()
      .forEach((key) => {
        
        const isActive = this.resolutionData[key]["ActiveResolutionCode"];
        if (this.resolutionData[key].modules.includes(module) && isActive) {
          if (module == "variance") {
            data.push({ label: key, value: key });
          } 
          else{
            if (
              ((module == "waste_assay" || module == "waste_recon") &&
                !this.resolutionData[key].diversion_risk.includes(
                  "Practice Issue"
                )) ||
              (module != "waste_assay" && module != "waste_recon")
            )
              // MV2-483
              //new line
              data.push({ label: key, value: key });
          }
          
        }
      });
    return data;
  }

  getRosolutionCodeData(module: any) {
    const data: any[] = [];
    Object.keys(this.resolutionData)
      .sort()
      .forEach((key) => {
        const isActive = this.resolutionData[key]["ActiveResolutionCode"];
        if (this.resolutionData[key].modules.includes(module) && isActive)
          if (
            ((module == "waste_assay" || module == "waste_recon") &&
              !this.resolutionData[key].diversion_risk.includes(
                "Practice Issue"
              )) ||
            (module != "waste_assay" && module != "waste_recon")
          )
            // MV2-483
            //new line
            data.push({ label: key, value: key });
      });
    return data;
  }

  getUoms() {
    return [
      {
        label: "Select",
        value: "",
      },
      {
        label: "Application",
        value: "Application",
      },
      {
        label: "bottle",
        value: "bottle",
      },
      {
        label: "cap",
        value: "cap",
      },
      {
        label: "gel",
        value: "gel",
      },
      {
        label: "kit",
        value: "kit",
      },
      {
        label: "lozenge",
        value: "lozenge",
      },
      {
        label: "mcg",
        value: "mcg",
      },
      {
        label: "mgs",
        value: "mgs",
      },
      {
        label: "ml(s)",
        value: "ml(s)",
      },
      {
        label: "patch",
        value: "patch",
      },
      {
        label: "pellet",
        value: "pellet",
      },
      {
        label: "sl film",
        value: "sl film",
      },
      {
        label: "supp",
        value: "supp",
      },
      {
        label: "tab",
        value: "tab",
      },
    ];
  }

  getAuditFollowUptatusBg(val: any) {
    switch(val){
      //case "Close": return "res-bg-green";
      case "Continue Surveillance": return "res-bg-yellow";
      case "DDPT Investigation": return "res-bg-red";
      case "DDPT Provided Education": return "res-bg-green";
      case "DDPT Review - Initiated": return "res-bg-light-blue";
      case "DDPT Review - Closed": return "res-bg-green";
      case "DDPT Review - Low Risk": return "res-bg-green";
      case "DDPT Review - Med Risk": return "res-bg-yellow";
      case "DDPT Review - High Risk": return "res-bg-light-red";
      case "DDPT Terminated": return "res-bg-red";
      case "Open": return "";
      case "Unit Mgn/DDPT Review - High": return "res-bg-light-red";
      case "Unit Mgn/DDPT Review - Low": return "res-bg-green";
      case "Unit Mgn/DDPT Review - Med": return "res-bg-yellow";
      case "Unit Provided Education": return "res-bg-green";
      case "Admin Response Pending": return "res-bg-light-purple";
      default: return ""
    }
  }

  getAuditFollowUpStatusOptions() {
    return [
      { label: "Open", value: "Open" },
      { label: "DDPT Review - Initiated", value: "DDPT Review - Initiated" },
      { label: "DDPT Review - Low Risk", value: "DDPT Review - Low Risk" },
      { label: "DDPT Review - Med Risk", value: "DDPT Review - Med Risk" },
      { label: "DDPT Review - High Risk", value: "DDPT Review - High Risk" },
      { label: "Continue Surveillance", value: "Continue Surveillance" },
      { label: "Admin Response Pending", value: "Admin Response Pending" },
      { label: "Unit Mgn/DDPT Review - Low", value: "Unit Mgn/DDPT Review - Low" },
      { label: "Unit Mgn/DDPT Review - Med", value: "Unit Mgn/DDPT Review - Med" },
      { label: "Unit Mgn/DDPT Review - High", value: "Unit Mgn/DDPT Review - High" },
      { label: "DDPT Investigation", value: "DDPT Investigation" },
      { label: "DDPT Provided Education", value: "DDPT Provided Education" }, 
      { label: "DDPT Terminated", value: "DDPT Terminated" },           
      { label: "DDPT Review - Closed", value: "DDPT Review - Closed" },
    ];
    
    // return [
    //   { label: "Open", value: "Open" },
    //   { label: "DDPT Review - Low Risk", value: "DDPT Review - Low Risk" },
    //   {
    //     label: "Unit Mgn/DDPT Review - Low",
    //     value: "Unit Mgn/DDPT Review - Low",
    //   },
    //   { label: "DDPT Provided Education", value: "DDPT Provided Education" },
    //   { label: "Unit Provided Education", value: "Unit Provided Education" },
    //   { label: "Continue Surveillance", value: "Continue Surveillance" },
    //   {
    //     label: "Unit Mgn/DDPT Review - Med",
    //     value: "Unit Mgn/DDPT Review - Med",
    //   },
    //   //{label:"Unit Mgn/DDPT Review - Med",value:"Unit Mgn/DDPT Review - Med"},
    //   {
    //     label: "Unit Mgn/DDPT Review - High",
    //     value: "Unit Mgn/DDPT Review - High",
    //   },
    //   { label: "DDPT Investigation", value: "DDPT Investigation" },
    //   { label: "DDPT Terminated", value: "DDPT Terminated" },
    //   { label: "", value: "" },
    // ];
  }

  //For fetching the Practice Issue Options from the db for MV2-337
  getPracticeIssueOptions() {
    const data: any[] = [];
    Object.keys(this.practiceIssueData)
      .sort()
      .forEach((key) => {
        data.push({ label: key, value: key });
      });
    return data;
  }
  /**MV2:431 getting resolution code for the on mouse over on audit page */
  getRiskLevelResolutions() {
    const data: any[] = [];
    Object.keys(this.resolutionData)
      .sort()
      .forEach((key) => {
        const isActive = this.resolutionData[key]["ActiveResolutionCode"];
        if (isActive) {
          if (data[this.resolutionData[key]["diversion_risk"]] == undefined)
            data[this.resolutionData[key]["diversion_risk"]] = [];
          data[this.resolutionData[key]["diversion_risk"]].push(key);
        }
      });
      Object.keys(this.practiceIssueData)
      .sort()
      .forEach((key) => {
      
          if ((data as any)['Practice Issue'] == undefined)
             (data as any)['Practice Issue'] = [];
             (data as any)['Practice Issue'].push(key);
        
      });
      
    return data;
  }
   /** MP:122 and MP:123*/
   getNewResolutionCode() {
    return this.http.get(environment.apiUrl + "get/resolution_codes").pipe(
      tap(res => {
        this.resolutionData = (res as any)[0]
        this.practiceIssueData = (res as any)[1]
      })
    );
  }
}
